export default __webpack_public_path__ + "static/media/modulePregnancyPLUS_1.0c2a157a.mp4";